// 从 localStorage 读取初始值，页面刷新后自动恢复登录状态
const getToken = () => {
    return localStorage.getItem('token') || ''
}
const getUserId = () => {
    return localStorage.getItem('userId') || ''
}
const getUserName = () => {
    return localStorage.getItem('userName') || ''
}
const getPreTestFinished = () => localStorage.getItem('preTestFinished') === 'true'
const getCourseFinished = () => localStorage.getItem('courseFinished') === 'true'
const getPostTestFinished = () => localStorage.getItem('postTestFinished') === 'true'

export default {
    // 命名空间，避免和其他模块重名
    namespaced: true,

    state: {
        token: getToken(),
        userId: getUserId(),
        userName: getUserName(),
        // 初始化优先读localStorage，消除页面刷新闪烁
        preTestFinished: false,
        postTestFinished: false,
        courseFinished: false
    },

    mutations: {
        // 保存 token
        SET_TOKEN(state, token) {
            state.token = token
            localStorage.setItem('token', token)
        },
        // 保存用户信息
        SET_USER_INFO(state, payload) {
            state.userId = payload.userId
            state.userName = payload.userName
            localStorage.setItem('userId', payload.userId)
            localStorage.setItem('userName', payload.userName)
        },
        // 🔴新增：更新问卷、课程完成状态
        SET_SURVEY_STATUS(state, payload) {
            if(payload.preTestFinished !== undefined){
                state.preTestFinished = payload.preTestFinished
            }
            if(payload.postTestFinished !== undefined){
                state.postTestFinished = payload.postTestFinished
            }
            if(payload.courseFinished !== undefined){
                state.courseFinished = payload.courseFinished
            }
        },
        // 退出登录：清空 vuex + localStorage
        CLEAR_USER(state) {
            state.token = ''
            state.userId = ''
            state.userName = ''
            // 退出时清空内存状态
            state.preTestFinished = false
            state.postTestFinished = false
            state.courseFinished = false

            localStorage.removeItem('token')
            localStorage.removeItem('userId')
            localStorage.removeItem('userName')
        }
    },

    actions: {},
    getters: {}
}